import * as yup from 'yup'
import { WebhookEventType, WebhookResourceType } from 'src/constants/webhook/enums'

/**
 * All three fields are required because `AdminManualWebhookSendDto` requires all three —
 * `resourceId` is `@IsString()` with no `@IsOptional`. `eventDetails` is not in this form at all;
 * the backend defaults it.
 *
 * `oneOf`'s whitelist check runs as one of yup's internal tests, which always execute before
 * `required`'s own test — so for the unchosen `''` state (not `null`/`undefined`, so `required`
 * alone would never catch it) the message actually surfaced is `oneOf`'s, not `required`'s. Both
 * are given the same copy so the field reads the same "choose one" message whether the value is
 * unchosen or (defensively) outside the backend enum.
 */
export const sendTestWebhookValidator = yup.object({
  eventType: yup
    .mixed<WebhookEventType>()
    .oneOf(Object.values(WebhookEventType), 'Choose an event to simulate')
    .required('Choose an event to simulate'),
  resourceType: yup
    .mixed<WebhookResourceType>()
    .oneOf(Object.values(WebhookResourceType), 'Choose a resource type')
    .required('Choose a resource type'),
  resourceId: yup.string().trim().required('Resource ID is required'),
})
